import { useEffect, useContext, useRef, useState } from "react";
import { post } from "../../../../adapters/xhr/api";
import stylesModal from "./Modal.module.css";

import stylesRequestData from "../../UnifiedTaxDeclarationRequestData/index.module.css";
import SearchSelectElement from "../../../../shared/form/SearchSelectElement";
import InputElement from "../../../../shared/form/InputElement";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import FieldRenderer from "../common/FieldRendrer";
import Modal from "react-modal";
import { useLocation, useNavigate } from "react-router-dom";

// import MultiSelectElement from "../../../shared/form/MultiSelectElement";

const ServiceUnitForm = ({
  generateOptions,
  serviceUnitTypes,
  unitAttachments,
  error_new_user,
  setValidFields,
  handleChangeDeclerationUnit,
  ownershipDeedFileInputRef,
  leaseContractFileInputRef,
  setUploadFileError,
  setError,
  fileInputKeys,
  DownloadFile,
  handlePreviewFile,
  setTempFiles,
}) => {
  Modal.setAppElement("body");
  const location = useLocation();
  const licensePhotoFileInputRef = useRef(null);

  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    declarationRequest,
    updateDeclarationUnit,
    isUnitInSameBuilding,
    getUnitInitialValue,
    showPropertyTypeModal,
    setShowPropertyTypeModal,
    propertyTypes,
    setDeclarationRequest,
    reasonForExemption,
  } = unifiedTaxDeclarationContext;

  const [fileErrors, setFileErrors] = useState({});

  const specialLawReasonLabel = "Exemption by special law - إعفاء بقانون خاص";

  const selectedExemptionReason = reasonForExemption?.find(
    (reason) =>
      String(reason?.id) === String(declarationRequest?.unit?.exemption_reason),
  );

  const exemptedValue = String(
    declarationRequest?.unit?.exempted ?? "",
  ).toLowerCase();
  const isExempted =
    declarationRequest?.unit?.exempted === 1 ||
    declarationRequest?.unit?.exempted === true ||
    exemptedValue === "1" ||
    exemptedValue === "true";
  const navigate = useNavigate();
  const isSpecialLawReason =
    selectedExemptionReason?.name?.includes("إعفاء بقانون خاص") ||
    String(declarationRequest?.unit?.exemption_reason) === "11";

  useEffect(() => {
    // console.log("selectedExemptionReason:", selectedExemptionReason);
    // console.log("isSpecialLawReason:", isSpecialLawReason);
    // console.log("exemption_reason:", declarationRequest?.unit?.exemption_reason);
    // console.log("reasonForExemption:", reasonForExemption);
  }, [
    declarationRequest?.unit?.exemption_reason,
    selectedExemptionReason,
    reasonForExemption,
  ]);

  useEffect(() => {
    if (parseInt(declarationRequest?.unit?.property_type_id) === 4) {
      handleChangeDeclerationUnit("", "", "usage_type", "غير سكني");

      if (String(declarationRequest?.unit?.unit_type_id || "") !== "3") {
        handleChangeDeclerationUnit("", "", "unit_type_id", "3");
      }
    }
  }, [
    // handleChangeDeclerationUnit,
    declarationRequest?.unit?.property_type_id,
    declarationRequest?.unit?.unit_type_id,
    declarationRequest?.unit?.usage_type,
  ]);

  const formFields = ({
    declarationRequest,
    error_new_user,
    serviceUnitTypes,
    handleChangeDeclerationUnit,
    generateOptions,
    stylesRequestData,
    reasonForExemption,
    isSpecialLawReason,
  }) => [
    {
      type: "input",
      colClass: "col-md-4",
      name: "usage_type",
      labelText: "نوع الإستخدام",
      labelHtmlFor: "usage_type",
      inputType: "text",
      maxLength: 24,
      allowedPattern: /^(?!.*؟)(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/,
      value: declarationRequest?.unit?.usage_type,
      disabled: true,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.usage_type,
      stylesRequestData,
      required: true,
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "area",
      labelText: "المساحة",
      placeholder: "ادخل المساحة..",
      labelHtmlFor: "area",
      inputType: "text",
      allowedPattern: /^(?!0+(?:\.0{0,2})?$)\d{1,7}(?:\.\d{0,2})?$/,
      value: declarationRequest?.unit?.area || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.area,
      stylesRequestData,
      required: true,
    },
    {
      type: "select",
      colClass: "col-md-4",
      name: "unit_type_id",
      labelText: "نوع الوحدة",
      labelHtmlFor: "unit_type_id",
      options: generateOptions(serviceUnitTypes),
      // defaultText: commericalUnitTypes[1],
      value: declarationRequest?.unit?.unit_type_id,
      disabled: true,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.unit_type_id,
      stylesRequestData,
      required: true,
      valueType: "string",
    },
    {
      type: "input",
      colClass: "col-md-4",
      name: "activity_type",
      labelText: "نوع النشاط",
      placeholder: "ادخل نوع النشاط..",
      labelHtmlFor: "activity_type",
      inputType: "text",
      maxLength: 100,
      allowedPattern:
        /^(?!.*[0-9])[A-Za-z\u0621-\u063A\u0641-\u064A\-_,.\/\\\s]+$/,
      value: declarationRequest?.unit?.activity_type || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.activity_type,
      stylesRequestData,
      required: true,
    },
    {
      type: "checkbox",
      name: "exempted",
      id: "exempted",
      labelHtmlFor: "date",
      required: false,
      text: "هل الوحدة معفاه؟",
      secondText: "الدليل المستخدم",
      checked: isExempted,
      onChange: (e) => {
        const checked = e.target.checked ? 1 : 0;
        handleChangeDeclerationUnit("", "", "exempted", checked);
        if (!checked) {
          handleChangeDeclerationUnit("", "", "exemption_reason", null);
          handleChangeDeclerationUnit("", "", "law_number", null);
          handleChangeDeclerationUnit("", "", "law_year", null);
        }
      },

      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      // isUnitInSameBuilding,
      errorText: error_new_user?.exempted,

      wrapperClassName: "list-group border-0 mb-3",
      labelClassName: `${stylesRequestData["list-group-item"]} list-group-item border-0 mb-3`,
      inputClassName: `${stylesRequestData["form-check-input"]} form-check-input ms-3`,
      textStyle: { fontSize: "16px", fontWeight: "bold" },
      errorClassName: "text-danger mb-0 mt-1 me-4 fw-bolder",
      errorId: "acknowledge_unwillingness_to_submit_documents_error",

      popover: {
        allowHtml: true,
        content: `<div class="exemption-popover-content" dir="rtl">
            <p class="exemption-popover-title">إعفاء الأبنية المملوكة للجمعيات:</p>
            <p>يشترط أن تكون الجمعية مسجلة وفقا لأحكام القانون وأن يكون العقار مستغل في الأغراض التي أنشئت من أجلها والموضحة بلائحة النظام الأساسي، ولا يسري الإعفاء متى كانت تؤجر الوحدات المملوكة لها للغير، ويراعى إرفاق كافة المستندات المؤيدة.</p>

            <p class="exemption-popover-title">إعفاء الأبنية المملوكة للمنظمات العمالية:</p>
            <p>يشترط أن تكون الأبنية مخصصة لمكاتب إدارتها أو للأغراض التي أنشئت من أجلها، ولا يسري الإعفاء متى كانت تؤجر الوحدات المملوكة لها للغير، ويراعى إرفاق كافة المستندات المؤيدة.</p>

            <p class="exemption-popover-title">إعفاء المؤسسات التعليمية:</p>
            <p>يشترط أن تكون غير هادفة للربح، ولا يسري الإعفاء متى كانت تؤجر الوحدات المملوكة لها للغير، ويراعى إرفاق كافة المستندات المؤيدة.</p>

            <p class="exemption-popover-title">إعفاء المستشفيات والمستوصفات:</p>
            <p>يشترط أن تكون غير هادفة للربح، ولا يسري الإعفاء متى كانت تؤجر الوحدات المملوكة لها للغير، ويراعى إرفاق كافة المستندات المؤيدة.</p>

            <p class="exemption-popover-title">إعفاء الملاجئ والمبرات:</p>
            <p>يشترط أن تكون غير هادفة للربح، ولا يسري الإعفاء متى كانت تؤجر الوحدات المملوكة لها للغير، ويراعى إرفاق كافة المستندات المؤيدة.</p>

            <p class="exemption-popover-title">إعفاء الأبنية المملوكة للأحزاب السياسية:</p>
            <p>يشترط أن تكون الأبنية مستخدمة في الأغراض المخصصة لها، ولا يسري الإعفاء متى كانت تؤجر الوحدات المملوكة لها للغير، ويراعى إرفاق كافة المستندات المؤيدة.</p>

            <p class="exemption-popover-title">إعفاء النقابات المهنية:</p>
            <p>يشترط أن تكون الأبنية مستخدمة في الأغراض المخصصة لها، ولا يسري الإعفاء متى كانت تؤجر الوحدات المملوكة لها للغير، ويراعى إرفاق كافة المستندات المؤيدة.</p>

            <p class="exemption-popover-title">الدور المخصصة للمناسبات الاجتماعية:</p>
            <p>يشترط أن تكون غير هادفة للربح، ولا يسري الإعفاء متى كانت تؤجر الوحدات المملوكة لها للغير، ويراعى إرفاق كافة المستندات المؤيدة.</p>

            <p class="exemption-popover-title">إعفاءات مقررة بقوانين خاصة:</p>
            <p>يتم توضيح السند القانوني وتحديد رقم القانون ونص الإعفاء، ويراعى إرفاق كافة المستندات المؤيدة.</p>
          </div>`,
      },

      stylesRequestData,
    },
    ...(isExempted
      ? [
          {
            type: "select",
            colClass: "col-md-4",
            name: "exemption_reason",
            labelText: "سبب الإعفاء",
            labelHtmlFor: "exemption_reason",
            options: generateOptions(reasonForExemption),
            defaultText: "اختار سبب الإعفاء..",
            value:
              declarationRequest?.unit?.exemption_reason !== null &&
              declarationRequest?.unit?.exemption_reason !== undefined
                ? String(declarationRequest?.unit?.exemption_reason)
                : null,
            onChange: (pc, c, key, value) => {
              handleChangeDeclerationUnit(pc, c, key, value);
              const selected = reasonForExemption?.find(
                (reason) => String(reason?.id) === String(value),
              );
              if (!selected || !selected?.name?.includes("إعفاء بقانون خاص")) {
                handleChangeDeclerationUnit("", "", "law_number", null);
                handleChangeDeclerationUnit("", "", "law_year", null);
              }
            },
            errorText: error_new_user?.exemption_reason,
            stylesRequestData,
            required: true,
            valueType: "string",
            disabled:
              declarationRequest?.viewMode ||
              declarationRequest?.isUnitViewMode,
            // isUnitInSameBuilding,
          },
          ...(isSpecialLawReason
            ? [
                {
                  type: "input",
                  colClass: "col-md-4",
                  name: "law_number",
                  labelText: "رقم القانون",
                  placeholder: "ادخل رقم القانون..",
                  labelHtmlFor: "law_number",
                  inputType: "text",
                  maxLength: 100,
                  allowedPattern:
                    /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/,
                  value: declarationRequest?.unit?.law_number || "",
                  disabled:
                    declarationRequest?.viewMode ||
                    declarationRequest?.isUnitViewMode,
                  // isUnitInSameBuilding,
                  onChange: handleChangeDeclerationUnit,
                  errorText: error_new_user?.law_number,
                  stylesRequestData,
                  required: true,
                },
                {
                  type: "input",
                  colClass: "col-md-4",
                  name: "law_year",
                  labelText: "سنة القانون",
                  placeholder: "ادخل سنة القانون..",
                  labelHtmlFor: "law_year",
                  inputType: "text",
                  maxLength: 100,
                  allowedPattern:
                    /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/,
                  value: declarationRequest?.unit?.law_year || "",
                  disabled:
                    declarationRequest?.viewMode ||
                    declarationRequest?.isUnitViewMode,
                  // isUnitInSameBuilding,
                  onChange: handleChangeDeclerationUnit,
                  errorText: error_new_user?.law_year,
                  stylesRequestData,
                  required: true,
                },
              ]
            : []),
        ]
      : []),
    {
      type: "input",
      colClass: "col-md-4",
      name: "market_value",
      labelText: "القيمة السوقية للوحدة",
      placeholder: "ادخل القيمة السوقية للوحدة..",
      labelHtmlFor: "market_value",
      inputType: "text",
      allowedPattern: /^(?!0+(?:\.0{0,2})?$)\d{1,19}(?:\.\d{0,2})?$/,
      value: declarationRequest?.unit?.market_value || "",
      disabled:
        declarationRequest?.viewMode || declarationRequest?.isUnitViewMode,
      onChange: handleChangeDeclerationUnit,
      errorText: error_new_user?.market_value,
      stylesRequestData,
      required: false,
    },
  ];

  const fields = formFields({
    declarationRequest,
    error_new_user,
    serviceUnitTypes,
    handleChangeDeclerationUnit,
    generateOptions,
    stylesRequestData,
    reasonForExemption,
    isSpecialLawReason,
  });

  const handleChangeUnitFile = async (pc, c, key, value, i, bi, fi, ref) => {
    try {
      const data = new FormData();
      data.append(`label`, key);
      data.append(`file`, value);

      if (value) {
        const response = await post(
          "api/declaration-system/declarations/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );

        // setDeclarationRequest((prev) => ({
        //   ...prev,
        //   [key]: response?.data?.data,
        // }));
        updateDeclarationUnit(key, response?.data?.data);
        setError(key, "");
        setUploadFileError(null);
        setFileErrors((prev) => ({ ...prev, [key]: "" }));
        if (location?.pathname?.includes("add") && !declarationRequest?.id) {
          setTempFiles((prev) => [...prev, response?.data?.data?.path]);
        }
      }
    } catch (error) {
      if (error.status === 422) {
        setValidFields((prev) => ({
          ...prev,
          key: false,
        }));
        // setDeclarationRequest((prev) => ({
        //   ...prev,
        //   [key]: null,
        // }));
        updateDeclarationUnit(key, null);
        window.scrollTo(0, 0);
        // setError(key, "يجب رفع الصورة");
        setUploadFileError(error?.response?.data?.errors?.file);
        setFileErrors((prev) => ({
          ...prev,
          [key]: error?.response?.data?.errors?.file?.[0] || "خطأ في الملف",
        }));
        if (ref?.current) {
          ref.current.value = null;
        }
      }
    }
  };

  const attachedEssentialDocuments = [
    {
      key: "ownership_deed",
      label: "مرفق سند تمليك الوحدة",
      file: declarationRequest?.unit?.ownership_deed,
    },
    {
      key: "lease_contract",
      label: "مرفق عقد إيجار الوحدة",
      file: declarationRequest?.unit?.lease_contract,
    },
    {
      key: "license_photo",
      label: "مرفق صورة الرخصة",
      file: declarationRequest?.unit?.license_photo,
    },
  ].filter((document) => document.file !== null && document.file !== undefined);

  const handleSelectPropertyTypeIdModal = () => {
    const selectedPropertyTypeId =
      declarationRequest?.unit?.property_type_id_modal;
    const selectedPropertyTypeInt = parseInt(selectedPropertyTypeId, 10);

    if (!selectedPropertyTypeId) {
      setError("property_type_id_modal", "يجب اختيار نوع العقار");
      return;
    }

    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...getUnitInitialValue(),
        buildingProfile: prev?.unit?.buildingProfile || null,
        known_build_num: prev?.unit?.known_build_num || null,
        address_additional_info: prev?.unit?.address_additional_info || null,
        is_map_address_matching: prev?.unit?.is_map_address_matching || null,
        mismatch_reason_id: prev?.unit?.mismatch_reason_id || null,
        correct_city_other: prev?.unit?.correct_city_other || null,
        correct_district_other: prev?.unit?.correct_district_other || null,
        correct_mogawra_other: prev?.unit?.correct_mogawra_other || null,
        correct_village_other: prev?.unit?.correct_village_other || null,
        correct_street_other: prev?.unit?.correct_street_other || null,
        correct_settlement_other: prev?.unit?.correct_settlement_other || null,
        correct_astrick_colour: prev?.unit?.correct_astrick_colour || null,

        filter_search_type_id: prev?.unit?.filter_search_type_id ?? 3,
        renin: prev?.unit?.manual_renin || prev?.unit?.renin || null,
        manual_city: prev?.unit?.manual_city || null,
        manual_district: prev?.unit?.manual_district || null,
        manual_governorate_id: prev?.unit?.manual_governorate_id || null,
        manual_governorate_name: prev?.unit?.manual_governorate_name || null,
        manual_known_build_num: prev?.unit?.manual_known_build_num || null,
        manual_mogawra: prev?.unit?.manual_mogawra || null,
        manual_policestation_id: prev?.unit?.manual_policestation_id || null,
        manual_policestation_name:
          prev?.unit?.manual_policestation_name || null,
        manual_renin: prev?.unit?.manual_renin || null,
        manual_settlement: prev?.unit?.manual_settlement || null,
        manual_street: prev?.unit?.manual_street || null,
        manual_village: prev?.unit?.manual_village || null,

        property_type_id: selectedPropertyTypeId,
        property_type_id_modal: selectedPropertyTypeId,
        usage_type:
          selectedPropertyTypeInt === 1
            ? "سكني"
            : [2, 3, 4].includes(selectedPropertyTypeInt)
              ? "غير سكني"
              : null,
      },
    }));

    setError("property_type_id_modal", "");
    setShowPropertyTypeModal(false);
  };
  return (
    <>
      <Modal
        isOpen={showPropertyTypeModal}
        // onRequestClose={() => setShowPropertyTypeModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        {" "}
        <div className="col-lg-8 w-100 w-md-75">
          <SearchSelectElement
            mb4="mb-4"
            labelHtmlFor="property_type_id_modal"
            labelClassName={` required form-label ${stylesRequestData["form-label"]} text-center`}
            labelText="نوع العقار"
            selectClassName={`${stylesRequestData["form-select"]} form-select `}
            selectID="property_type_id_modal"
            inputId="property_type_id_modal_input"
            name="property_type_id_modal"
            options={generateOptions(propertyTypes)}
            default="أختار نوع العقار .."
            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
            pText={error_new_user.property_type_id_modal}
            value={declarationRequest?.unit?.property_type_id_modal}
            onChange={handleChangeDeclerationUnit}
            isClearable={true}
            disabled={
              declarationRequest?.viewMode || declarationRequest?.isUnitViewMode
            }
          />
        </div>
        <div className="d-flex gap-2 justify-content-start flex-wrap">
          <button
            className="btn btn-primary px-4 py-2"
            onClick={handleSelectPropertyTypeIdModal}
          >
            إضافة عقار جديد
          </button>

          <button
            className="btn btn-primary px-4 py-2"
            onClick={() => {
              setShowPropertyTypeModal(false);
              setDeclarationRequest({
                ...declarationRequest,
                isShowOnlyUnit: false,
                isUnitEditMode: false,
                isUnitViewMode: false,
              });
              if (declarationRequest?.id) {
                navigate(`/tax-declaration/update/${declarationRequest?.id}`);
              }
            }}
          >
            إلغاء
          </button>
        </div>
      </Modal>

      {fields.map((field) => (
        <FieldRenderer key={field.name} field={field} />
      ))}

      {!declarationRequest?.viewMode && !declarationRequest?.isUnitViewMode && (
        <>
          <div className="col-md-4">
            <InputElement
              fileInputRef={ownershipDeedFileInputRef}
              mb4="mb-4"
              key={`agency-${fileInputKeys.ownership_deed}`}
              inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
              labelHtmlFor="ownership_deed"
              labelClassName={` ${stylesRequestData["form-label"]} form-label  `}
              labelText="سند تمليك الوحدة"
              inputType="file"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="ownership_deed_input"
              name="ownership_deed"
              fileName={
                declarationRequest?.unit?.ownership_deed?.original_file_name ||
                "إرفاق ملف"
              }
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              icon="fa-solid fa-cloud-arrow-up"
              accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
              pText={fileErrors["ownership_deed"]}
              hideErrorMessage
              onChange={handleChangeUnitFile}
              customServerInput={
                declarationRequest?.unit?.ownership_deed !== null ? true : false
              }
              disabled={
                declarationRequest?.viewMode ||
                declarationRequest?.isUnitViewMode
              }
              deleteFunction={() => {
                handleChangeDeclerationUnit("", "", "ownership_deed", null);
                if (ownershipDeedFileInputRef?.current) {
                  ownershipDeedFileInputRef.current.value = null;
                }
              }}
            />
          </div>
          <div className="col-md-4">
            <InputElement
              fileInputRef={leaseContractFileInputRef}
              mb4="mb-4"
              key={`agency-${fileInputKeys.lease_contract}`}
              inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
              labelHtmlFor="lease_contract"
              labelClassName={`${stylesRequestData["form-label"]} form-label  `}
              labelText="عقد إيجار الوحدة"
              inputType="file"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="lease_contract_input"
              name="lease_contract"
              fileName={
                declarationRequest?.unit?.lease_contract?.original_file_name ||
                "إرفاق ملف"
              }
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              icon="fa-solid fa-cloud-arrow-up"
              accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
              pText={fileErrors["lease_contract"]}
              hideErrorMessage
              onChange={handleChangeUnitFile}
              customServerInput={
                declarationRequest?.unit?.lease_contract !== null ? true : false
              }
              disabled={
                declarationRequest?.viewMode ||
                declarationRequest?.isUnitViewMode
              }
              deleteFunction={() => {
                handleChangeDeclerationUnit("", "", "lease_contract", null);
                if (leaseContractFileInputRef?.current) {
                  leaseContractFileInputRef.current.value = null;
                }
              }}
            />
          </div>
          <div className="col-md-4">
            <InputElement
              fileInputRef={licensePhotoFileInputRef}
              mb4="mb-4"
              key={`license-${fileInputKeys.license_photo}`}
              inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
              labelHtmlFor="license_photo"
              labelClassName={`${stylesRequestData["form-label"]} form-label  `}
              labelText="صورة الرخصة"
              inputType="file"
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="license_photo_input"
              name="license_photo"
              fileName={
                declarationRequest?.unit?.license_photo?.original_file_name ||
                "إرفاق ملف"
              }
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              icon="fa-solid fa-cloud-arrow-up"
              accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
              pText={fileErrors["license_photo"]}
              hideErrorMessage
              onChange={handleChangeUnitFile}
              customServerInput={
                declarationRequest?.unit?.license_photo !== null ? true : false
              }
              disabled={
                declarationRequest?.viewMode ||
                declarationRequest?.isUnitViewMode
              }
              deleteFunction={() => {
                handleChangeDeclerationUnit("", "", "license_photo", null);
                if (licensePhotoFileInputRef?.current) {
                  licensePhotoFileInputRef.current.value = null;
                }
              }}
            />
          </div>
        </>
      )}

      {(declarationRequest?.viewMode || declarationRequest?.isUnitViewMode) &&
        attachedEssentialDocuments.length > 0 && (
          <div className={`${stylesRequestData.box} box pdf-box`}>
            <h4 className={`${stylesRequestData["box-title"]} box-title mb-4`}>
              قائمة المستندات الأساسية
            </h4>
            <div className="row">
              {attachedEssentialDocuments.map((document) => (
                <div className="col-md-4" key={document.key}>
                  <label
                    htmlFor={document.key}
                    className={`${stylesRequestData["form-label"]} form-label`}
                  >
                    {document.label}
                  </label>
                  <div className=" col-2-4 d-flex border border-2  rounded-3 shadow-sm fs-6 justify-content-between bg-light py-2 px-2 align-items-center mb-3">
                    <p
                      className="mb-0 file-name fs-6"
                      title={document.file?.original_file_name}
                    >
                      {document.file?.original_file_name}
                    </p>
                    <div className="d-flex align-items-center py-2">
                      <span
                        type="button"
                        onClick={() =>
                          handlePreviewFile(document.file?.full_url)
                        }
                        className={`text-danger border-0`}
                      >
                        <i
                          className="fa-slab-press fa-regular fa-eye fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                      <span
                        type="button"
                        onClick={() => DownloadFile(document.file?.full_url)}
                        className={`text-danger border-0`}
                      >
                        <i
                          className="fa-solid fa-cloud-arrow-down fa-lg px-2"
                          style={{ color: "#32A8ED" }}
                        ></i>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
    </>
  );
};

export default ServiceUnitForm;
